<template>
	<section>
		<div class='dropdown' >

			<div id='groupClient'>

                <input id="myclients-input-dropdown" type="checkbox" checked>
                <label for="myclients-input-dropdown" class="animate">Clientes</label>
                <ul id='myclients'>
					<section v-for="item in getCurrentMensagens" :key="item.text_prev+'_'+item.time+'_'+item.nome">
						<div class="myclientscreated" v-if="item.operador != ''">		
							<li  class=" animate ">	
									<item-todas-mensagens
										class="custom-message p-2"
										@click.native="setCurrentConversa(item.key)"
										:avatar_url="item.avatar"
										:time="item.time"
										:nome="item.nome"
										:notify="item.notify"
										:operador="item.operador"
										:prev_text="item.text_prev"></item-todas-mensagens>
							</li>
						</div>
					</section>
                </ul>
            </div>

			<div id="groupQueue" class="mt-4">

                <input id="queueclients-input-dropdown" type="checkbox" checked>
                <label for="queueclients-input-dropdown" class="animate">Fila</label>
                <ul id='queueClients'>
					<section v-for="(item) in getCurrentMensagens" :key="item.text_prev+'_'+item.time+'_'+item.nome">
						<section v-if="item.operador == ''">
						<li  class=" animate ">
							<div v-if="item.operador == ''">			
								<!-- <section v-if="index  == 0"> -->
								<section>
									<item-todas-mensagens
										class="custom-message p-2"
										@click.native="setCurrentConversa(item.key)"
										:avatar_url="item.avatar"
										:time="item.time"
										:nome="item.nome"
										:notify="item.notify"
										:operador="item.operador"
										:prev_text="item.text_prev"></item-todas-mensagens>
								</section>
							</div>
						</li>
						</section>
					</section>
                </ul>

            </div>

		</div>
	</section>
</template>

<script>
import {mapGetters, mapMutations, mapActions} from 'vuex';
import ItemTodasMensagens from "./ItemTodasMensagens";
export default {
	data: function(){
		return {
			test: 0
		}
	},
	name: "TodasMenssagensChat",
	components: {ItemTodasMensagens},
	computed: {
		...mapGetters(['getCurrentMensagens', 'getExtension'])
	},
	methods: {
		...mapMutations(['setCurrentConversa']), 
		...mapActions(['joinQueue','newEntry','removeClient', 'operatorInUse', 'feedbackStartChat', 'disconnect'])
	},
	mounted(){
        var x = this.getExtension()
        this.joinQueue(x)
        this.newEntry();
        this.removeClient()
		this.operatorInUse();
		this.feedbackStartChat();
		this.disconnect();
    }
}
</script>

<style scoped>

/* border-right: solid 2px #1C869A;
border-radius: 0% 2% 2% 0%; */
	.custom-message {
		/* border-bottom: 1px solid gray; */
		cursor: pointer;
		padding: 0px !important; /* !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!! */ 
		/* background: white; */
	}

	*{
		padding: 0;
		margin: 0;
		font-family: 'Lato', sans-serif;
		box-sizing: border-box;
	}
	.float-right{
		float: right;
	}
	.fa{
		font-size: .8em;
		line-height: 22px !important;
	}

	.dropdown label, .dropdown ul li{
		display: block;
		/* width: 200px; */
		background: #ECF0F1;
		padding: 15px 20px;
	}

	.dropdown label:hover, .dropdown ul li:hover{
		background: #1c869a;
		color: white;
		cursor: pointer;
	}

	.dropdown label{
		color: #1c869a;
		border-left: 4px solid #1c869a;
		border-radius: 0 5px 0 0; 
		position: relative;
		z-index: 2;
	}

	.dropdown #myclients-input-dropdown{
		display: none;
	}
	.dropdown #queueclients-input-dropdown{
		display: none;
	}

	input:checked + label{
		background: #1c869a;
		color: white;
	}

	#groupClient input ~ ul{
		position: relative;
		visibility: hidden;
		display:none;
		opacity: 0;
		top: -20px;
		z-index: 1;
	}

	#groupClient input:checked ~ ul{
		visibility: visible;
		display: block;
		opacity: 1;
		top: 0;
	}


	#groupQueue input ~ ul{
		position: relative;
		visibility: hidden;
		opacity: 0;
		top: -20px;
		z-index: 1;
	}
	
	#groupQueue input:checked ~ ul{
		visibility: visible;
		opacity: 1;
		top: 0;
	}

	.animate{
		-webkit-transition: all .3s;
		-moz-transition: all .3s;
		-ms-transition: all .3s;
		-ms-transition: all .3s;
		transition: all .3s;  
		backface-visibility:hidden;
		-webkit-backface-visibility:hidden; /* Chrome and Safari */
		-moz-backface-visibility:hidden; /* Firefox */
		-ms-backface-visibility:hidden; /* Internet Explorer */
	}
	#queueClients > section:first-of-type{
		background-color: green !important;
	}
</style>
